// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ptr[data-v-0be4928f]{cursor:pointer}`, "",{"version":3,"sources":["webpack://./ClientApp/components/kanban/modal/responsible/responsiblemodal.vue.html"],"names":[],"mappings":"AACA,sBACI,cAAA","sourcesContent":["\n.ptr {\n    cursor: pointer\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
